module.exports = __webpack_public_path__ + "img/xcx.5cf95a87.jpeg";